<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>Time Slots{{ franchisee.name ? ` - ${franchisee.name}` : "" }}</span>
          <v-spacer></v-spacer>
          <!-- <v-btn v-can:add="['franchisees', 'franchise_details']" color="primary" rounded @click="openSlotDialog()">
            <v-icon left>mdi-plus</v-icon>
            Add Slot
          </v-btn> -->
        </v-card-title>
        <v-card-text>
          <p class="text-caption grey--text" v-if="timeSlots.length">
            30-min slots are auto-generated from Working from/Working Till.
            Use the toggle to disable a slot.
          </p>
          <section v-if="isLoading" style="height: 200px">
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </section>
          <v-simple-table v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Sr No</th>
                  <th class="text-left">Start Time</th>
                  <th class="text-left">End Time</th>
                  <th class="text-left">Status</th>
                  <th class="text-left" style="min-width: 160px">
                    Created At
                  </th>
                  <th class="text-left">Actions</th>
                </tr>
              </thead>
              <tbody v-if="timeSlots.length != 0">
                <tr
                  v-for="(slot, slotIndex) in timeSlots"
                  :key="`slot_${slot.id}`"
                >
                  <td>{{ slotIndex + 1 }}</td>
                  <td>{{ slot.start_time }}</td>
                  <td>{{ slot.end_time }}</td>
                  <td>
                    <v-chip
                      small
                      :color="slot.is_active ? 'green' : 'grey'"
                      text-color="white"
                    >
                      {{ slot.is_active ? "Active" : "Disabled" }}
                    </v-chip>
                  </td>
                  <td style="min-width: 160px">
                    {{ formatDate(slot.created_at) }}
                  </td>
                  <td>
                    <!-- <v-btn icon small @click="openSlotDialog(slot)">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn> -->
                    <v-switch
                      class="d-inline-block mb-0"
                      hide-details
                      dense
                      inset
                      :input-value="slot.is_active"
                      @change="toggleSlotActive(slot)"
                    ></v-switch>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5" class="text-center">
                    No time slots yet. Set "Working from"/"Working Till" on
                    this franchisee first.
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="slotDialog" max-width="500" persistent>
        <v-card>
          <v-card-title>{{ slotForm.id ? "Edit" : "Add" }} Time Slot</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="6">
                <v-menu
                  ref="slot_start_menu"
                  v-model="slotStartMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="slotForm.start_time"
                      label="Start Time"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="slotErrors.start_time"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="slotStartMenu"
                    v-model="slotForm.start_time"
                    full-width
                    :allowed-minutes="allowedStep"
                    @click:minute="$refs.slot_start_menu.save(slotForm.start_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="slot_end_menu"
                  v-model="slotEndMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="slotForm.end_time"
                      label="End Time"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="slotErrors.end_time"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="slotEndMenu"
                    v-model="slotForm.end_time"
                    full-width
                    :min="slotForm.start_time"
                    :allowed-minutes="allowedStep"
                    @click:minute="$refs.slot_end_menu.save(slotForm.end_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="slotDialog = false">Cancel</v-btn>
            <v-btn v-can:edit="['franchisees', 'franchise_details']"
              color="primary"
              :loading="isSlotSaving"
              :disabled="isSlotSaving"
              @click="saveSlot"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "FranchiseeTimeSlotsPage",
  data() {
    return {
      franchiseeId: null,
      franchisee: {},
      timeSlots: [],
      isLoading: false,
      slotDialog: false,
      slotStartMenu: false,
      slotEndMenu: false,
      isSlotSaving: false,
      slotForm: {},
      slotErrors: {},
    };
  },
  mounted() {
    this.franchiseeId = this.$route.query.franchisee_id
      ? parseInt(this.decryptIt(this.$route.query.franchisee_id))
      : null;
    this.getFranchisee();
    this.getTimeSlots();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    allowedStep: (m) => m % 30 === 0,
    async getFranchisee() {
      if (!this.franchiseeId) return;
      await axios
        .get(`/franchisees/${this.encryptIt(this.franchiseeId)}`)
        .then((response) => {
          this.franchisee = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getTimeSlots() {
      this.isLoading = true;
      await axios
        .get("/franchisee_time_slots", {
          params: { franchisee_id: this.franchiseeId },
        })
        .then((response) => {
          this.timeSlots = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        });
      this.isLoading = false;
    },
    openSlotDialog(slot) {
      this.slotErrors = {};
      this.slotForm = slot
        ? { id: slot.id, start_time: slot.start_time, end_time: slot.end_time }
        : { start_time: null, end_time: null };
      this.slotDialog = true;
    },
    async saveSlot() {
      this.slotErrors = {};
      if (!this.slotForm.start_time || !this.slotForm.end_time) {
        this.slotErrors = {
          start_time: !this.slotForm.start_time ? ["Required"] : [],
          end_time: !this.slotForm.end_time ? ["Required"] : [],
        };
        return;
      }
      this.isSlotSaving = true;
      try {
        if (this.slotForm.id) {
          await axios.patch(
            `/franchisee_time_slots/${this.encryptIt(this.slotForm.id)}`,
            this.slotForm
          );
        } else {
          await axios.post("/franchisee_time_slots", {
            franchisee_id: this.franchiseeId,
            start_time: this.slotForm.start_time,
            end_time: this.slotForm.end_time,
          });
        }
        this.slotDialog = false;
        await this.getTimeSlots();
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.slotErrors = error.response.data.errors || {};
          if (error.response.data["sub-title"]) {
            this.slotErrors.start_time = [error.response.data["sub-title"]];
          }
        } else {
          console.error(error);
        }
      } finally {
        this.isSlotSaving = false;
      }
    },
    async toggleSlotActive(slot) {
      try {
        await axios.patch(`/franchisee_time_slots/${this.encryptIt(slot.id)}`, {
          start_time: slot.start_time,
          end_time: slot.end_time,
          is_active: !slot.is_active,
        });
        await this.getTimeSlots();
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
